import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3003/api';

/**
 * Crear nueva ruta optimizada
 */
export const createRoute = async (messengerId, orderIds, routeDate) => {
  const response = await axios.post(
    `${API_URL}/routes/create`,
    { messengerId, orderIds, routeDate },
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * Obtener ruta activa del mensajero autenticado
 */
export const getActiveRoute = async () => {
  const response = await axios.get(
    `${API_URL}/routes/active`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * Iniciar ruta
 */
export const startRoute = async (routeId) => {
  const response = await axios.put(
    `${API_URL}/routes/${routeId}/start`,
    {},
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * Cerrar ruta
 */
export const closeRoute = async (routeId, closeData) => {
  const response = await axios.put(
    `${API_URL}/routes/${routeId}/close`,
    closeData,
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * Obtener todas las rutas
 */
export const getAllRoutes = async () => {
  const response = await axios.get(
    `${API_URL}/routes`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * Obtener ruta por ID
 */
export const getRouteById = async (routeId) => {
  const response = await axios.get(
    `${API_URL}/routes/${routeId}`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * Obtener órdenes de una ruta
 */
export const getRouteOrders = async (routeId) => {
  const response = await axios.get(
    `${API_URL}/routes/${routeId}/orders`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * Marcar pedido como entregado (legacy)
 */
export const completeOrderDelivery = async (orderId, deliveryData) => {
  const response = await axios.post(
    `${API_URL}/messenger/orders/${orderId}/complete`,
    deliveryData,
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * 🆕 Obtener ítems del pedido (para rechazo parcial en entrega)
 */
export const getOrderItems = async (orderId) => {
  const response = await axios.get(
    `${API_URL}/messenger/orders/${orderId}/items`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * Iniciar entrega de un pedido
 */
export const startOrderDelivery = async (orderId) => {
  const response = await axios.post(
    `${API_URL}/messenger/orders/${orderId}/start-delivery`,
    {},
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * Subir evidencia fotográfica de entrega
 */
export const uploadDeliveryEvidence = async (orderId, payload) => {
  // If payload is already FormData, use it directly (contains photo + description/coords)
  // Otherwise, wrap the file in a new FormData
  const formData = (payload instanceof FormData) ? payload : new FormData();
  if (!(payload instanceof FormData)) {
    formData.append('photo', payload);
  }

  const response = await axios.post(
    `${API_URL}/messenger/orders/${orderId}/upload-evidence`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return response.data;
};

/**
 * Registrar ubicación del mensajero
 */
export const updateLocation = async (routeId, latitude, longitude) => {
  const response = await axios.post(
    `${API_URL}/routes/${routeId}/location`,
    { latitude, longitude },
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * 🆕 [PHASE 1] Marcar entrega como fallida con evidencia (v2)
 */
export const markOrderFailedV2 = async (orderId, data) => {
  const formData = new FormData();
  formData.append('failureReason', data.failureReason);
  if (data.failureNotes) formData.append('failureNotes', data.failureNotes);
  if (data.isBadlyRouted) formData.append('isBadlyRouted', data.isBadlyRouted);
  if (data.failurePhoto) formData.append('failurePhoto', data.failurePhoto);
  if (data.latitude) formData.append('latitude', data.latitude);
  if (data.longitude) formData.append('longitude', data.longitude);

  const response = await axios.post(
    `${API_URL}/messenger/orders/${orderId}/mark-failed-v2`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return response.data;
};

/**
 * 🆕 [PHASE 1] Corregir dirección de entrega fallida
 */
export const correctOrderAddress = async (orderId, data) => {
  const response = await axios.post(
    `${API_URL}/messenger/orders/${orderId}/correct-address`,
    data,
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};

/**
 * 🆕 [PHASE 1] Actualizar dirección de un pedido (Mensajero)
 */
export const updateOrderAddress = async (orderId, newAddress, notes) => {
  const response = await axios.post(
    `${API_URL}/messenger/orders/${orderId}/address`,
    { newAddress, notes },
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );
  return response.data;
};
